export default __webpack_public_path__ + "static/440x290@2x-43f1c16ffbb021194394ba33c56f0b2f.png";